import { createFileRoute } from '@tanstack/react-router';

import { OfferImportListPage } from '@/areas/offers/OfferImports/OfferImportListPage';
import { canViewPartLibrarySourcing } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';
import { SidebarPageContent } from '@/shared/ui/PageLayoutCollapsibleSidebar';

// Only the new navigation has this page: no route of today's leads here.
export const Route = createFileRoute('/_authenticated/next/offer-imports/')({
    staticData: { access: { permissions: canViewPartLibrarySourcing }, chrome: 'none' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return (
        <SidebarPageContent layoutVariant="fullWidth">
            <OfferImportListPage />
        </SidebarPageContent>
    );
}
